import {
  trackReportDownload,
  trackEventOnMixpanel,
  trackGTMEvent,
} from "lib/utils";

import type { Report } from "content-ui/intelligence/types";

const downloadPDF = (pdf: string) => {
  window.open(pdf);
};

const downloadReportClick = (
  pdf: string,
  name: string,
  marketingConsentState: boolean,
  reportId: string
) => {
  trackGTMEvent({
    event: "report download",
    reportName: name,
    marketingConsent: marketingConsentState,
    userId: window.tp?.userId?.getUser()?.uid || null,
  });

  trackEventOnMixpanel({
    eventName: "Report download",
    fields: {
      title: name,
      path: window.location.href,
    },
  });

  trackReportDownload(reportId);

  downloadPDF(pdf);
};

const canAccessContent = (report: Report, readerSubscriptionLevel: string) => {
  if (report["membershipLevel"] === "Pro") {
    if (readerSubscriptionLevel === "pro") {
      return true;
    } else {
      return false;
    }
  } else if (report["membershipLevel"] === "Member") {
    if (readerSubscriptionLevel !== "unregistered") {
      return true;
    } else {
      return false;
    }
  } else {
    // Free content
    return true;
  }
};

export { downloadReportClick, canAccessContent };
